import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#1a0d2e] py-12 px-4" data-id="element-292">
      <div className="max-w-5xl mx-auto" data-id="element-293">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-294">
          <div data-id="element-295">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-296">
              +300
            </div>
            <div className="text-[#A855F7] text-sm font-semibold mt-1" data-id="element-297">
              instructores confían
            </div>
          </div>
          <div data-id="element-298">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-299">6</div>
            <div className="text-[#A855F7] text-sm font-semibold mt-1" data-id="element-300">
              Tomos listos
            </div>
          </div>
          <div data-id="element-301">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-302">6</div>
            <div className="text-[#A855F7] text-sm font-semibold mt-1" data-id="element-303">
              Bonos incluidos
            </div>
          </div>
          <div data-id="element-304">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-305">
              4.9/5
            </div>
            <div className="text-[#A855F7] text-sm font-semibold mt-1" data-id="element-306">
              calificación ⭐
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-307">
          <div className="flex items-start gap-3 bg-black/40 border border-[#A855F7]/20 rounded-xl p-4" data-id="element-308">
            <div className="w-10 h-10 rounded-full bg-[#A855F7]/20 flex items-center justify-center text-[#A855F7] font-black text-sm flex-shrink-0" data-id="element-309">
              MG
            </div>
            <div data-id="element-310">
              <div className="text-[#A855F7] text-xs mb-1" data-id="element-311">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-312">
                "Organicé todo el año en una tarde. Las fichas de seguimiento me
                ahorran horas cada semana."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-313">
                — Marcela G., Córdoba
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#A855F7]/20 rounded-xl p-4" data-id="element-314">
            <div className="w-10 h-10 rounded-full bg-[#A855F7]/20 flex items-center justify-center text-[#A855F7] font-black text-sm flex-shrink-0" data-id="element-315">
              LP
            </div>
            <div data-id="element-316">
              <div className="text-[#A855F7] text-xs mb-1" data-id="element-317">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-318">
                "El Tomo Clínico por fin me da el criterio para trabajar con
                hernias y escoliosis sin miedo. Vale cada peso."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-319">
                — Laura P., Rosario · Studio de Pilates
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#A855F7]/20 rounded-xl p-4" data-id="element-320">
            <div className="w-10 h-10 rounded-full bg-[#A855F7]/20 flex items-center justify-center text-[#A855F7] font-black text-sm flex-shrink-0" data-id="element-321">
              RM
            </div>
            <div data-id="element-322">
              <div className="text-[#A855F7] text-xs mb-1" data-id="element-323">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-324">
                "Mis clases grupales dejaron de ser un caos. El sistema de
                estaciones es un antes y un después."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-325">
                — Roberto M., Buenos Aires
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}